export default __webpack_public_path__ + "static/media/Order-Details.5ebb0558.jpg";